<template>
  <div id="app">
    <!-- 顶部环境光晕层 -->
    <div class="tech-ambient-glow tech-glow-top"></div>
    <div class="tech-ambient-mesh"></div>
    
    <!-- 路由主视口 -->
    <div class="app-main-content">
      <router-view></router-view>
    </div>

    <!-- 底部环境光晕层 -->
    <div class="tech-ambient-glow tech-glow-bottom"></div>
  </div>
</template>

<script>
export default {
  name: 'app',
}
</script>

<style lang="scss">
@import "@/assets/custom_theme.scss";

#app {
  font-family: -apple-system, BlinkMacSystemFont, 'SF Pro Display', 'Segoe UI', Roboto, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #FFFFFF;
  background-color: #021210;
  background-image: 
    radial-gradient(ellipse 80% 50% at 50% -10%, rgba(0, 229, 163, 0.22) 0%, transparent 80%),
    radial-gradient(ellipse 70% 40% at 50% 110%, rgba(0, 229, 163, 0.18) 0%, transparent 75%),
    linear-gradient(180deg, #021210 0%, #001f1b 50%, #01110f 100%);
  min-height: 100vh;
  max-width: 500px;
  margin: 0 auto;
  position: relative;
  overflow-x: hidden;
  box-shadow: 0 0 60px rgba(0, 0, 0, 0.8);
}

/* 顶部与底部极光科技氛围 */
.tech-ambient-glow {
  position: fixed;
  pointer-events: none;
  z-index: 0;
  border-radius: 50%;
  filter: blur(60px);
}

.tech-glow-top {
  top: -120px;
  left: 50%;
  transform: translateX(-50%);
  width: 320px;
  height: 240px;
  background: radial-gradient(circle, rgba(0, 229, 163, 0.35) 0%, rgba(0, 210, 255, 0.15) 50%, transparent 70%);
}

.tech-glow-bottom {
  bottom: -100px;
  left: 50%;
  transform: translateX(-50%);
  width: 360px;
  height: 200px;
  background: radial-gradient(circle, rgba(0, 229, 163, 0.25) 0%, transparent 70%);
}

/* 科技流线背景纹理 */
.tech-ambient-mesh {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  max-width: 500px;
  margin: 0 auto;
  pointer-events: none;
  z-index: 0;
  opacity: 0.18;
  background-image: 
    radial-gradient(rgba(0, 229, 163, 0.3) 1px, transparent 1px),
    repeating-linear-gradient(45deg, rgba(0, 229, 163, 0.03) 0, rgba(0, 229, 163, 0.03) 1px, transparent 0, transparent 40px);
  background-size: 24px 24px, auto;
}

.app-main-content {
  position: relative;
  z-index: 1;
}
</style>
